import { render, staticRenderFns } from "./DisplayDetail.vue?vue&type=template&id=7e67dd4a&scoped=true"
import script from "./DisplayDetail.vue?vue&type=script&lang=js"
export * from "./DisplayDetail.vue?vue&type=script&lang=js"
import style0 from "./DisplayDetail.vue?vue&type=style&index=0&id=7e67dd4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e67dd4a",
  null
  
)

export default component.exports